module.exports = __webpack_public_path__ + "img/tire.293e67cd.png";